import { ArrowRight, Check } from 'lucide-react';
import { cn } from '@/lib/cn';

type JourneyStep = 'fdaia' | 'al3viewer' | 'mvc';

interface UserJourneyProps {
  currentStep: JourneyStep;
  sessionId?: string;
  className?: string;
}

const STEPS = [
  { id: 'fdaia' as JourneyStep, label: 'CK FDS', icon: '●' },
  { id: 'al3viewer' as JourneyStep, label: 'AL3VIEWER', icon: '●' },
  { id: 'mvc' as JourneyStep, label: 'M-VC', icon: '●' },
];

export function UserJourney({ currentStep, sessionId, className }: UserJourneyProps) {
  const currentIndex = STEPS.findIndex(s => s.id === currentStep);

  return (
    <div className={cn('flex flex-col gap-3 border-b border-ck-dark-border bg-black px-4 py-3 md:flex-row md:items-center md:justify-between md:px-6 md:py-4', className)}>
      <div className="flex flex-wrap items-center gap-2 md:gap-3">
        <span className="text-xs font-semibold uppercase tracking-wider text-ck-cyan">User Journey</span>
        {STEPS.map((step, index) => {
          const isComplete = index < currentIndex;
          const isActive = index === currentIndex;
          const isNext = index > currentIndex;

          return (
            <div key={step.id} className="flex items-center gap-1.5 md:gap-2">
              {index > 0 && (
                <ArrowRight className={cn(
                  'h-3 w-3 md:h-4 md:w-4',
                  isComplete ? 'text-ck-purple' : 'text-muted-foreground'
                )} />
              )}
              <div
                className={cn(
                  'flex items-center gap-1.5 rounded-full border-2 px-2 py-1 transition-all md:gap-2 md:px-4 md:py-2',
                  isComplete && 'border-ck-purple bg-ck-purple/20',
                  isActive && 'border-ck-cyan bg-ck-cyan/20',
                  isNext && 'border-ck-dark-border bg-ck-dark-card'
                )}
              >
                <div className={cn(
                  'flex h-3 w-3 items-center justify-center rounded-full text-xs md:h-4 md:w-4',
                  isComplete && 'bg-ck-purple text-white',
                  isActive && 'bg-ck-cyan text-black',
                  isNext && 'bg-muted-foreground text-ck-dark'
                )}>
                  {isComplete ? <Check className="h-2 w-2 md:h-3 md:w-3" /> : step.icon}
                </div>
                <span className={cn(
                  'text-xs font-medium md:text-sm',
                  isComplete && 'text-ck-purple',
                  isActive && 'text-ck-cyan',
                  isNext && 'text-muted-foreground'
                )}>
                  {step.label} <span className="hidden md:inline">{isActive && 'ACTIVE'}</span>
                </span>
              </div>
            </div>
          );
        })}
      </div>
      {sessionId && (
        <span className="text-xs text-ck-purple md:ml-auto">SESSION: {sessionId}</span>
      )}
    </div>
  );
}